import { render, staticRenderFns } from "./TicimaxChannelDashboard.vue?vue&type=template&id=8f4116a0&scoped=true"
import script from "./TicimaxChannelDashboard.vue?vue&type=script&lang=js"
export * from "./TicimaxChannelDashboard.vue?vue&type=script&lang=js"
import style0 from "./TicimaxChannelDashboard.vue?vue&type=style&index=0&id=8f4116a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4116a0",
  null
  
)

export default component.exports